import { computed as b } from "vue";
import { toCamelCase as m, ucfirst as $ } from "./util.js";
const k = ["", "Sm", "Md", "Lg", "Xl", "2xl"];
function d(t, f, s, { additional: n = [], short: r = !1, vertical: l = !1 } = {}) {
  const i = [...n];
  for (const e of f)
    for (const u of k) {
      let a = u;
      const p = e ? `${e}${u}` : u.toLowerCase();
      if (!p)
        continue;
      e && a.match(/^[0-9]/) && (a = `_${a}`);
      let o = t[p] === "" ? !0 : t[p];
      if (o) {
        if (o === !0)
          o = "";
        else {
          if (typeof o != "string")
            continue;
          o = m(o), !r && o.match(/^[0-9]/) && (o = `_${o}`);
        }
        let c = `${o}${a ? `On${a}${l ? "Height" : ""}` : ""}`;
        e ? r || (c = `${m(e)}${$(c)}`) : c = `show${$(c)}`, i.push(s.modifiers[c]);
      }
    }
  return i.filter(Boolean);
}
function x(t, f, s) {
  const n = {};
  for (const r of k) {
    const l = `${f}${r}`;
    let i = s;
    r && (i = `${i}-on-${r.toLowerCase()}`);
    const e = t[l];
    e != null && (n[i] = t[l]);
  }
  return n;
}
function B(t, f, s, n) {
  return b(() => d(t, f, s, n));
}
export {
  k as breakpoints,
  d as classesFromBreakpointProps,
  x as cssVarsFromBreakpointProps,
  B as useBreakpointProp
};
